import { Navigate, useLocation } from 'react-router-dom';

/**
 * Old /checkout/qr-payment/:productId route. Payment now lives at /checkout/pay/:orderId,
 * which works without router state; anything else goes to the buyer's orders.
 */
const QRPaymentPage = () => {
  const { state } = useLocation();
  const orderId = state?.orderId;

  return orderId ? (
    <Navigate to={`/checkout/pay/${encodeURIComponent(orderId)}`} replace />
  ) : (
    <Navigate to="/profile" replace />
  );
};

export default QRPaymentPage;
